import { render, staticRenderFns } from "./BTN004n_diagonal_ left.vue?vue&type=template&id=c0f61dda&scoped=true&"
import script from "./BTN004n_diagonal_ left.vue?vue&type=script&lang=js&"
export * from "./BTN004n_diagonal_ left.vue?vue&type=script&lang=js&"
import style0 from "./BTN004n_diagonal_ left.vue?vue&type=style&index=0&id=c0f61dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f61dda",
  null
  
)

export default component.exports